import {
  isSupportedLanguage,
  type SupportedLanguage,
} from '@/shared/config/languages'

function resolveInviteUrl(magicLinkUrl: string): URL | null {
  const trimmed = magicLinkUrl.trim()
  if (trimmed.length === 0) {
    return null
  }

  try {
    return new URL(trimmed)
  } catch {
    if (typeof window !== 'undefined') {
      try {
        return new URL(trimmed, window.location.origin)
      } catch {
        return null
      }
    }
    return null
  }
}

export function withCatalogSupplierInviteLanguage(
  magicLinkUrl: string,
  language: SupportedLanguage
): string {
  const resolved = resolveInviteUrl(magicLinkUrl)
  if (resolved == null) {
    return ''
  }
  resolved.searchParams.set('lng', language)
  return resolved.toString()
}

export function readInviteLanguageFromMagicLinkUrl(
  magicLinkUrl: string
): SupportedLanguage {
  const resolved = resolveInviteUrl(magicLinkUrl)
  if (resolved == null) {
    return 'en-GB'
  }
  const lng = resolved.searchParams.get('lng')
  if (lng != null && isSupportedLanguage(lng)) {
    return lng
  }
  return 'en-GB'
}
